




















import { Component, Prop, Vue } from "vue-property-decorator";
import { Location } from "vue-router";

@Component
export default class HomePage extends Vue {
  @Prop() public readonly link!: string | Location;
  @Prop() public readonly icon!: string;
  @Prop() public readonly title!: string;
  @Prop() public readonly subtitle!: string;
}
